import React from 'react';
import {
  Badge,
  Button,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default props => {
  const { entity } = props;

  const isDenyAction =
    entity.association !== null && entity.association.common_area_only;
  const isSubmitted = entity.status === 0 && entity.approved === 0;
  const isApproved = entity.approved === 1;
  const isDisabled =
    entity.association === null ||
    (entity.master_cert_only === 0 &&
      entity.association !== null &&
      entity.unit === null);
  return (
    <Row>
      <Col>
        <div className={'float-left mr-3'}>
          <FontAwesomeIcon icon={['fas', 'home']} className={'fa-3x'} />
        </div>
        <div className={'color-blue font-md float-left'}>
          Evidence of Insurance
          {entity.master_cert_only === 1 && (
            <Badge color={'primary ml-2'}>Master Certificate Only</Badge>
          )}
          {entity.pending === 1 && (
            <Badge color={'warning'} className={'ml-2'}>
              Pending
            </Badge>
          )}
          {entity.on_hold_internal === 1 && (
            <Badge color={'warning'} className={'ml-2'}>
              On Hold - Internal
            </Badge>
          )}
        </div>
        <div className={'float-right d-flex'}>
          {entity.master_cert_only === 0 && (
            <Button
              color={'link'}
              className={'mr-3 px-2'}
              onClick={props.onPreviewClick}
            >
              Preview
            </Button>
          )}
          <Button
            className={'btn-transparent px-4'}
            onClick={() => props.toggleModal('sendModal')}
          >
            Email / Fax
          </Button>

          {isApproved &&
            entity.chargeable === 1 &&
            entity.qb_invoice_id === null &&
            (props.entity.invoice_email.length === 0 ||
              props.entity.association === null ||
              props.entity.unit === null ||
              props.entity.evidence_of_insurance_pricing === null) && (
              <Button className={'btn-warning px-4 ml-3'} disabled={true}>
                Create Invoice
              </Button>
            )}

          {isApproved &&
            entity.chargeable === 0 &&
            entity.status === 0 &&
            entity.master_cert_only === 1 && (
              <Button
                className={'btn-warning px-4 ml-3'}
                onClick={() => props.toggleModal('deliveredModal')}
              >
                Mark as Delivered
              </Button>
            )}

          {isApproved &&
            entity.chargeable === 1 &&
            entity.qb_invoice_id === null &&
            !(
              props.entity.invoice_email.length === 0 ||
              props.entity.association === null ||
              props.entity.unit === null ||
              props.entity.evidence_of_insurance_pricing === null
            ) && (
              <Button
                className={'btn-warning px-4 ml-3'}
                onClick={e => props.createInvoice()}
              >
                Create Invoice
              </Button>
            )}

          {entity.qb_invoice_sent === 0 && entity.qb_invoice_id !== null && (
            <Button
              className={'btn-warning px-4 ml-3'}
              onClick={props.sendQBInvoice}
            >
              Email Invoice
            </Button>
          )}
          {isSubmitted && (
            <React.Fragment>
              {entity.association === null ? (
                <Button className={'btn-warning px-4 ml-3'} disabled={true}>
                  Approve
                </Button>
              ) : (
                <React.Fragment>
                  {entity.master_cert_only === 1 ? (
                    <React.Fragment>
                      {isDenyAction ? (
                        <Button
                          className={'btn-warning px-4 ml-3'}
                          onClick={() => props.toggleModal('denyModal')}
                        >
                          Deny
                        </Button>
                      ) : (
                        <Button
                          className={'btn-warning px-4 ml-3'}
                          onClick={() => props.toggleModal('approveModal')}
                        >
                          Approve
                        </Button>
                      )}
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      {isDenyAction ? (
                        <Button
                          className={'btn-warning px-4 ml-3'}
                          onClick={() => props.toggleModal('denyModal')}
                        >
                          Deny
                        </Button>
                      ) : (
                        <Button
                          className={'btn-warning px-4 ml-3'}
                          onClick={() => props.toggleModal('approveModal')}
                          disabled={isDisabled}
                        >
                          Approve
                        </Button>
                      )}
                    </React.Fragment>
                  )}
                </React.Fragment>
              )}
            </React.Fragment>
          )}

          <UncontrolledDropdown className={'ml-3'}>
            <DropdownToggle caret color={'transparent'}>
              More Options
            </DropdownToggle>
            <DropdownMenu right>
              {entity.status === 0 ? (
                <React.Fragment>
                  {isSubmitted && (
                    <React.Fragment>
                      <DropdownItem
                        disabled={isDisabled}
                        onClick={
                          isDisabled
                            ? null
                            : () => props.toggleModal('approveModal')
                        }
                      >
                        Approve
                      </DropdownItem>

                      <DropdownItem
                        onClick={() => props.toggleModal('denyModal')}
                      >
                        Deny
                      </DropdownItem>
                    </React.Fragment>
                  )}
                  {/* isSubmitted && <DropdownItem>Void</DropdownItem> */}
                  {entity.approved === -1 && (
                    <DropdownItem
                      onClick={() => props.toggleModal('reinstateModal')}
                    >
                      Reinstate
                    </DropdownItem>
                  )}

                  {entity.pending === 0 ? (
                    <DropdownItem
                      onClick={() => props.toggleModal('pendingModal')}
                    >
                      Pending
                    </DropdownItem>
                  ) : (
                    <DropdownItem
                      onClick={() => props.toggleModal('pendingModal')}
                    >
                      Unmark as Pending
                    </DropdownItem>
                  )}
                  {entity.on_hold_internal === 0 ? (
                    <DropdownItem
                      onClick={() => props.toggleModal('onHoldModal')}
                    >
                      On Hold - Internal
                    </DropdownItem>
                  ) : (
                    <DropdownItem
                      onClick={() => props.toggleModal('onHoldModal')}
                    >
                      Unmark as On Hold - Internal
                    </DropdownItem>
                  )}

                  <DropdownItem
                    onClick={() => props.toggleModal('confirmModal')}
                  >
                    Delete
                  </DropdownItem>
                </React.Fragment>
              ) : (
                <DropdownItem disabled={true}>
                  No options available
                </DropdownItem>
              )}
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>
      </Col>
    </Row>
  );
};
